import React, { createContext, useContext, useReducer, useCallback, useMemo } from 'react';
import { user, initialUserState } from './reducers';

export const StateContext = createContext(initialUserState);

export const StateProvider = ({
  // eslint-disable-next-line react/prop-types
  children,
}) => {
  // Use useCallback to memoize combineReducers for React 18 compatibility
  const combineReducers = useCallback((slices) => (prevState, action) =>
    Object.keys(slices).reduce(
      (nextState, nextProp) => ({
        ...nextState,
        [nextProp]: slices[nextProp](prevState[nextProp], action),
      }),
      prevState
    ), []);

  const [state, dispatch] = useReducer(combineReducers({ user }), {
    user: initialUserState,
  });

  // Use useMemo to create a stable context value that only changes when state actually changes
  const contextValue = useMemo(() => ({
    state,
    dispatch,
    user: state.user
  }), [state]);

  return (
    <StateContext.Provider value={contextValue}>
      {children}
    </StateContext.Provider>
  );
};

export const UseGlobalState = () => useContext(StateContext);
